/**
 * The API returns timestamps as '2022-03-30 12:35:06.690682' — a space
 * separator with microsecond precision, which browsers parse inconsistently.
 * Converting to a strict ISO 8601 string keeps parsing consistent.
 */
export const toIsoTimestamp = (value: string): string => value.replace(' ', 'T').replace(/(\.\d{3})\d+/, '$1');
